module.exports = __webpack_public_path__ + "img/analysis_subjective_unshare_white_1.1cfb65c8.svg";